import React from 'react'
import HeroSection from '../components/heroSection/HeroSection'
import Cards from '../components/Services/cards'
import { Helmet } from "react-helmet";


function Services() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Services | Al Ghaith Properties</title>
        <meta name="description" content="Explore our full range of real estate services, including property management, leasing, and investment solutions in Dubai." />
        <link rel="canonical" href="https://www.al-ghaith.ae/services" />
      </Helmet>
      <div data-aos="zoom-in">
        <HeroSection page={"SERVICES"} />
        <Cards />
      </div>
    </>
  )
}

export default Services